import React from 'react';
import { Link } from 'react-router-dom';
import { FiMapPin, FiPhone, FiMail, FiFacebook, FiLock } from 'react-icons/fi';
import { FaAirbnb } from 'react-icons/fa';
import { SiBookingdotcom } from 'react-icons/si';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-brand-olive text-brand-cream pt-16 pb-8 border-t-4 border-brand-dark">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12 text-center md:text-left">
          {/* Brand Col */}
          <div className="flex flex-col items-center md:items-start">
            <div className="mb-6 flex items-center justify-center md:justify-start">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/51a91a93706672e53ae444a23254479bc2f5b1a8165fab41d806a43d2b869fef8268d071e9340f739bfeb737c7b371ae/images/aW1hZ2UvcG5n/6dcc5579ab51daebcf49818da283daab.png" 
                alt="R. Venue Apartelle Logo" 
                className="w-56 md:w-64 h-auto object-contain mix-blend-lighten"
              />
            </div>
            <p className="text-brand-light font-light leading-relaxed max-w-xs">
              A clean, welcoming, and nature-inspired getaway in the heart of Lucban, Quezon. Your relaxing home away from home.
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-start space-y-3">
            <h4 className="font-serif text-xl mb-4 text-brand-white">Explore</h4>
            <Link to="/" className="text-brand-light hover:text-white transition-colors duration-300">Home</Link>
            <Link to="/stay" className="text-brand-light hover:text-white transition-colors duration-300">The Stay</Link>
            <Link to="/gallery" className="text-brand-light hover:text-white transition-colors duration-300">Gallery</Link>
            <Link to="/location" className="text-brand-light hover:text-white transition-colors duration-300">Location</Link>
            <Link to="/rates" className="text-brand-light hover:text-white transition-colors duration-300">Rates & Booking</Link>
          </div>

          {/* Contact Col */}
          <div className="flex flex-col items-center md:items-start space-y-4">
            <h4 className="font-serif text-xl mb-4 text-brand-white">Contact Us</h4>
            <div className="flex items-start gap-3 text-brand-light">
              <SafeIcon icon={FiMapPin} className="mt-1 flex-shrink-0" />
              <span>
                3rd Floor R. Venue Bldg Quezon Ave,<br/>
                cor Avenida Rizal, Lucban,<br/>
                4328 Quezon, Philippines
              </span>
            </div>
            <div className="flex items-center gap-3 text-brand-light">
              <SafeIcon icon={FiPhone} />
              <span>+63 917 681 8251</span>
            </div>
            <div className="flex items-center gap-3 text-brand-light">
              <SafeIcon icon={FiMail} />
              <span>hello@rvenueapartelle.com</span>
            </div>
            
            <div className="flex items-center gap-4 mt-6">
              <a 
                href="https://www.facebook.com/p/R-Venue-Apartelle-100092378052113/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-brand-dark flex items-center justify-center text-white hover:bg-brand-sage transition-colors duration-300"
                title="Follow us on Facebook"
              >
                <SafeIcon icon={FiFacebook} />
              </a>
              <a 
                href="https://www.airbnb.com/h/rvenueapartelle" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-brand-dark flex items-center justify-center text-white hover:bg-brand-sage transition-colors duration-300"
                title="Book on Airbnb"
              >
                <SafeIcon icon={FaAirbnb} />
              </a>
              <a 
                href="https://www.booking.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-brand-dark flex items-center justify-center text-white hover:bg-brand-sage transition-colors duration-300"
                title="Book on Booking.com"
              >
                <SafeIcon icon={SiBookingdotcom} className="text-xs" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-brand-sage text-center text-brand-light text-sm flex flex-col md:flex-row justify-between items-center">
          <div className="flex flex-col md:flex-row items-center gap-4">
            <p>&copy; {new Date().getFullYear()} R. VENUE Apartelle. All rights reserved.</p>
            <Link 
              to="/admin/login" 
              className="flex items-center gap-1 opacity-40 hover:opacity-100 transition-opacity text-[10px] uppercase tracking-widest bg-brand-dark/30 px-2 py-1 rounded-sm"
            >
              <SafeIcon icon={FiLock} /> Admin
            </Link>
          </div>
          <div className="space-x-4 mt-4 md:mt-0">
            <Link to="/rates" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/rates" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;